// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FlipBook Modal Styles */

.flipbook-modal .modal-dialog {
  max-width: 95vw;
  width: 95vw;
  margin: 1rem auto;
}

.flipbook-modal .modal-content {
  height: 95vh;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
}

.flipbook-modal .modal-header {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.5rem;
  background-color: #f8f9fa;
}

.flipbook-modal .modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.flipbook-modal .modal-body {
  flex: 1 1;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.flipbook-modal-body {
  padding: 0;
  background-color: #fff;
  height: 100%;
  position: relative;
}

/* Custom close button positioning */
.flipbook-modal-body .custom-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1050;
  background-color: transparent;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  transition: all 0.3s ease;
}

.flipbook-modal-body .custom-close-button:hover {
  background-color: transparent;
  box-shadow: none;
  transform: scale(1.1);
}

/* FlipBook container within modal */
.flipbook-modal .flipbook-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.flipbook-modal .flipbook-container {
  flex: 1 1;
  margin: 0;
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

/* Newsletter selector in modal */
.flipbook-modal .newsletter-selector {
  margin-top: 1rem;
  max-height: 150px;
}

.flipbook-modal .newsletter-buttons-container {
  max-height: 120px;
}

/* Title in modal */
.flipbook-modal .flipbook-title {
  margin-bottom: 0.5rem;
  padding: 0.75rem;
}

.flipbook-modal .flipbook-title h3 {
  font-size: 1.1rem;
}

/* Responsive styles for smaller screens */
@media (max-width: 768px) {
  .flipbook-modal .modal-dialog {
    max-width: 100vw;
    width: 100vw;
    margin: 0;
  }

  .flipbook-modal .modal-content {
    height: 100vh;
    border-radius: 0;
  }

  .flipbook-modal .modal-header {
    padding: 0.75rem 1rem;
  }

  .flipbook-modal .modal-title {
    font-size: 1.2rem;
  }

  .flipbook-modal-body {
    padding: 0;
  }

  .flipbook-modal-body .custom-close-button {
    top: 0.5rem;
    right: 0.5rem;
    width: 36px;
    height: 36px;
  }

  .flipbook-modal .flipbook-title h3 {
    font-size: 1rem;
  }

  .flipbook-modal .newsletter-selector {
    max-height: 100px;
  }

  .flipbook-modal .newsletter-buttons-container {
    max-height: 80px;
  }
}

/* Smooth animations */
.flipbook-modal .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}

.flipbook-modal.modal.fade.show .modal-dialog {
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/sass/layout/flipbook/flipbook-modal.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* FlipBook Modal Styles */\n\n.flipbook-modal .modal-dialog {\n  max-width: 95vw;\n  width: 95vw;\n  margin: 1rem auto;\n}\n\n.flipbook-modal .modal-content {\n  height: 95vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.flipbook-modal .modal-header {\n  border-bottom: 1px solid #dee2e6;\n  padding: 1rem 1.5rem;\n  background-color: #f8f9fa;\n}\n\n.flipbook-modal .modal-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.flipbook-modal .modal-body {\n  flex: 1;\n  overflow: hidden;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.flipbook-modal-body {\n  padding: 0;\n  background-color: #fff;\n  height: 100%;\n  position: relative;\n}\n\n/* Custom close button positioning */\n.flipbook-modal-body .custom-close-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 1050;\n  background-color: transparent;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  transition: all 0.3s ease;\n}\n\n.flipbook-modal-body .custom-close-button:hover {\n  background-color: transparent;\n  box-shadow: none;\n  transform: scale(1.1);\n}\n\n/* FlipBook container within modal */\n.flipbook-modal .flipbook-wrapper {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.flipbook-modal .flipbook-container {\n  flex: 1;\n  margin: 0;\n  border-radius: 0;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n/* Newsletter selector in modal */\n.flipbook-modal .newsletter-selector {\n  margin-top: 1rem;\n  max-height: 150px;\n}\n\n.flipbook-modal .newsletter-buttons-container {\n  max-height: 120px;\n}\n\n/* Title in modal */\n.flipbook-modal .flipbook-title {\n  margin-bottom: 0.5rem;\n  padding: 0.75rem;\n}\n\n.flipbook-modal .flipbook-title h3 {\n  font-size: 1.1rem;\n}\n\n/* Responsive styles for smaller screens */\n@media (max-width: 768px) {\n  .flipbook-modal .modal-dialog {\n    max-width: 100vw;\n    width: 100vw;\n    margin: 0;\n  }\n\n  .flipbook-modal .modal-content {\n    height: 100vh;\n    border-radius: 0;\n  }\n\n  .flipbook-modal .modal-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .flipbook-modal .modal-title {\n    font-size: 1.2rem;\n  }\n\n  .flipbook-modal-body {\n    padding: 0;\n  }\n\n  .flipbook-modal-body .custom-close-button {\n    top: 0.5rem;\n    right: 0.5rem;\n    width: 36px;\n    height: 36px;\n  }\n\n  .flipbook-modal .flipbook-title h3 {\n    font-size: 1rem;\n  }\n\n  .flipbook-modal .newsletter-selector {\n    max-height: 100px;\n  }\n\n  .flipbook-modal .newsletter-buttons-container {\n    max-height: 80px;\n  }\n}\n\n/* Smooth animations */\n.flipbook-modal .modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n}\n\n.flipbook-modal.modal.fade.show .modal-dialog {\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
